// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2_Snv","validationTips":"StatementDescriptor_validationTips__2sITm"};